// extracted by mini-css-extract-plugin
export default {"container":"DropdownIcon_container__Z+gnA","arrowColor":"DropdownIcon_arrowColor__pcZWq"};